export const ACCOUNT_SID = process.env.REACT_APP_ACCOUNT_SID;
export const VOICE_APP_SID = process.env.REACT_APP_VOICE_APP_SID;
export const FLEXCHAT_FLOW_SID = process.env.REACT_APP_FLEXCHAT_FLOW_SID;
export const FORM_ID = process.env.REACT_APP_FORM_ID;
export const KIOSK_ID = process.env.REACT_APP_KIOSK_ID;
export const VOICE_APP_CLI = process.env.REACT_APP_VOICE_APP_CLI;
export const IDENTITY = process.env.REACT_APP_IDENTITY;